import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import { SuggestedRoute } from "./components/SuggestedRoute";
import { getRouteDestination, getRouteOrigin } from "../../../../utils";
import { RoutePointDetail } from "../../../Shipment/components/RoutePointDetail";

import type { SuggestedRouteDeleteContext } from "./components/SuggestedRoute";

interface Props {
  error: string | null;
  route: Route | null;
  loading: boolean;
  displayRoutePointDates: boolean;
  suggestedRouteDeleteContext?: SuggestedRouteDeleteContext;
}

export function RouteTab(props: Props) {
  const {
    error,
    route,
    loading,
    displayRoutePointDates,
    suggestedRouteDeleteContext,
  } = props;
  if (loading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }
  if (error != null) {
    return (
      <Stack>
        <Typography color="red" align="center">
          {error}
        </Typography>
      </Stack>
    );
  }

  if (!route?.route_points || route.route_points.length < 1) {
    return (
      <Stack>
        <Typography align="center">No route points found.</Typography>
      </Stack>
    );
  }

  const midPoints = route?.route_points
    .filter((rp) => rp.stop_type !== "ORIGIN" && rp.stop_type !== "DESTINATION")
    .sort((a, b) => a.point_number - b.point_number);
  const origin = getRouteOrigin(route.route_points);
  const destination = getRouteDestination(route.route_points);
  return (
    <Stack direction="column" width="100%">
      {origin != null && (
        <RoutePointDetail
          routePoint={origin}
          displayRoutePointDates={displayRoutePointDates}
        />
      )}
      {midPoints.map((rp) => (
        <Box key={rp.point_number}>
          <RoutePointDetail
            routePoint={rp}
            displayRoutePointDates={displayRoutePointDates}
          />
        </Box>
      ))}
      {destination != null && (
        <RoutePointDetail
          routePoint={destination}
          displayRoutePointDates={displayRoutePointDates}
        />
      )}
      {origin != null && destination != null && midPoints && (
        <SuggestedRoute
          route={route}
          origin={origin}
          destination={destination}
          midPoints={midPoints}
          deleteContext={suggestedRouteDeleteContext}
        />
      )}
    </Stack>
  );
}
